module.exports = __webpack_public_path__ + "img/sorry.e40ad697.png";